import React from 'react';
import { useHistory } from 'react-router-dom';
import { styled } from '@this/constants/themes';
import { Box, Button, Typography } from '@material-ui/core';
import { Backdrop } from '../../common';

type Props = {
  needAuth: boolean;
  needReAuth: boolean;
  disconnectedAccounts: { email: string; message: string | null }[];
};

const AuthBackdrop = ({ needAuth, needReAuth, disconnectedAccounts }: Props) => {
  const history = useHistory();

  return (
    <>
      <Backdrop open={needAuth} style={{ flexDirection: 'column', backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
        <Box>
          <Typography style={{ textAlign: 'center' }}>ログインしてGoogle Calendarと連携</Typography>
          <Button
            style={{ display: 'block', margin: '0 auto' }}
            onClick={() => {
              window.open(history.createHref({ pathname: '/auth/new?provider=google' }));
            }}
          >
            <img src="/images/sign_in_with_google.png" width="191" />
          </Button>
        </Box>
        <Box>
          <Typography style={{ textAlign: 'center' }}>ログインしてOutlook Calendarと連携</Typography>
          <Button
            style={{ display: 'block', margin: '0 auto' }}
            onClick={() => {
              window.open(history.createHref({ pathname: '/auth/new?provider=outlook' }));
            }}
          >
            <img src="/images/sign_in_with_microsoft.png" width="215" />
          </Button>
        </Box>
      </Backdrop>
      <Backdrop open={needReAuth} style={{ flexDirection: 'column', backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
        <Box>
          <Typography style={{ textAlign: 'center' }}>
            {disconnectedAccounts.map((da, i) => (
              <p key={i}>
                {da.message
                  ? `Google Calendar(${da.email})への${da.message}`
                  : `Google Calendar(${da?.email})との連携が解除されています`}
              </p>
            ))}
          </Typography>
          <TheReAuthButton
            variant="contained"
            color="primary"
            style={{
              display: 'block',
              margin: '12px auto 0',
              textTransform: 'none'
            }}
            onClick={() => {
              window.open(history.createHref({ pathname: '/auth/new?provider=google' }));
            }}
          >
            Google Calendarと再連携
          </TheReAuthButton>
        </Box>
      </Backdrop>
    </>
  );
};

const TheReAuthButton = styled(Button)`
  span.MuiButton-label {
    display: block;
    position: relative;
    width: auto;
    padding-right: 25px;
    &:before {
      content: '';
      position: absolute;
      top: 8px;
      right: 2px;
      width: 6px;
      height: 6px;
      border-top: 2px solid #fff;
      border-right: 2px solid #fff;
      -webkit-transform: rotate(45deg);
      transform: rotate(45deg);
    }
  }
`;

export default AuthBackdrop;
